import React from 'react';
import { MapPin, Phone, Clock } from 'lucide-react';
import { businessInfo } from '../data/mock';
import { trackMaps } from '../lib/analytics';

const Location = () => {
  return (
    <section id="localizacao" className="py-20 bg-transparent">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Onde <span className="text-[#D4AF37]">Estamos</span>
          </h2>
          <p className="text-gray-400 text-lg">
            Venha nos visitar e conheça nossa estrutura premium
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div className="space-y-8">
            <div className="flex gap-4">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 bg-[#D4AF37]/10 rounded-sm flex items-center justify-center">
                  <MapPin className="h-6 w-6 text-[#D4AF37]" />
                </div>
              </div>
              <div>
                <h3 className="text-white text-xl font-semibold mb-2">Endereço</h3>
                <p className="text-gray-300 text-lg">{businessInfo.address.full}</p>
              </div>
            </div>

            <div className="flex gap-4">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 bg-[#D4AF37]/10 rounded-sm flex items-center justify-center">
                  <Phone className="h-6 w-6 text-[#D4AF37]" />
                </div>
              </div>
              <div>
                <h3 className="text-white text-xl font-semibold mb-2">Telefone</h3>
                <p className="text-gray-300 text-lg">(11) 93907-9671</p>
              </div>
            </div>

            <div className="flex gap-4">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 bg-[#D4AF37]/10 rounded-sm flex items-center justify-center">
                  <Clock className="h-6 w-6 text-[#D4AF37]" />
                </div>
              </div>
              <div>
                <h3 className="text-white text-xl font-semibold mb-2">Horário de Funcionamento</h3>
                <p className="text-gray-300 text-lg">
                  {businessInfo.hours.weekdays}: {businessInfo.hours.time}
                </p>
              </div>
            </div>

            <div className="pt-6">
              <a
                href="https://www.google.com/maps/search/?api=1&query=Avenida+Humberto+Cereser+523+Jundiaí+Mirim+Jundiaí+SP"
                target="_blank"
                rel="noopener noreferrer"
                onClick={trackMaps}
                data-testid="google-maps-btn"
                className="inline-block px-8 py-3 bg-[#D4AF37] hover:bg-[#B8941F] text-black font-semibold rounded-sm transition-all duration-300 hover:scale-105"
              >
                Ver no Google Maps
              </a>
            </div>
          </div>

          <div className="h-[500px] rounded-sm overflow-hidden border border-zinc-800">
            <iframe
              src={`https://www.google.com/maps/embed/v1/place?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&q=Avenida+Humberto+Cereser,+523,+Jundiaí+Mirim,+Jundiaí,+SP,+Brazil&zoom=17`}
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Localização ABR Barbearia"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Location;